<template>
    <div>
        <div class="lke-l-top-2">
            <p>学员姓名：<span>{{userInfo.name}}</span></p>
            <p>身份证号：<span>{{userInfo.uid}}</span></p>
            <p v-if="roles === 'headquarters' || roles === 'nonHeadquarters'">学习中心：<span>{{userInfo.college[0].name}}</span></p>
            <p v-if="roles === 'certificate'">证书简称：<span>{{userInfo.classes[0].name}}</span></p>
            <p>登录次数：<span>{{userInfo.loginlogCount}}</span>次登录</p>
            <p>上次登录：<span>{{userInfo.loginlogLastTime | addtime}}</span></p>
        </div>
    </div>
</template>

<script>
import moment from "moment"
export default {
    name: 'username',
    props: {

    },
    data() {
        return {

        };
    },
    filters: {
        addtime(val) {
            return moment(val).format("YYYY-MM-DD HH:mm:ss");
        },
    },
    computed: {
        userInfo() {
            return this.$store.state.userInfo
        },
        roles() {
            return this.$store.state.roles
        },
    },
    created() {

    },
    mounted() {

    },
    watch: {

    },
    methods: {

    },
    components: {

    },
};
</script>

<style>

</style>

<style scoped>
.lke-l-top-2{
    padding-top: 15px;
    font-size: 12px;
}
.lke-l-top-2 > p{
    line-height: 200%;
    color: #888888;
}
.lke-l-top-2 > p > span{
    color: #2890F4;
}
</style>



// WEBPACK FOOTER //
// src/pages/index/page/grzx/components/username.vue